<ng-container *ngIf="isHeader; else oepContainer">
  <div class="spinner-container" style="padding: .4rem;">
    <div
    [ngStyle]="{'bottom': diametr/2, 'left': diametr/2}"
    class="value">{{value}}%
    </div>
  </div>
</ng-container>

<ng-template #oepContainer>
  <div class="spinner-container">
    <mat-progress-spinner class="spinner"
        mode="determinate"
        appSpinnerColor="{{backgroundColor}}"
        value="100"
        [diameter]="diametr"
        [strokeWidth]="strokeWidth"
        >
    </mat-progress-spinner>
    <mat-progress-spinner
      class="spinner"
      [value]="value"
      [mode]="'determinate'"
      [diameter]="diametr"
      [strokeWidth]="strokeWidth"
      appSpinnerColor="{{color}}"
      [ngStyle]="{'bottom': diametr/2}">
    </mat-progress-spinner>
      <div
      [ngStyle]="{'bottom': diametr/2, 'left': diametr/2}"
      class="value">{{value}}%</div>
  </div>
</ng-template>
